export default __webpack_public_path__ + "static/media/Ecoin.20729506.svg";